import React from 'react';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

const SafeHtml = ({ html, as: Tag = 'span', ...props }) => (
  <Tag {...props}>{parse(DOMPurify.sanitize(html ?? ''))}</Tag>
);

export default SafeHtml;
